import React, { useMemo } from 'react';
import Modal from './Modal';
import { useShortcut, useShortcuts } from '../keyboard/ShortcutContext';
import { formatShortcut } from '../keyboard/shortcuts';
import './ShortcutSheet.css';

// The "?" sheet: every registered shortcut with a description, grouped.
// Mounted once in the app shell; it registers "?" itself.

export default function ShortcutSheet() {
  const { shortcuts, sheetOpen, setSheetOpen } = useShortcuts();
  useShortcut('?', () => setSheetOpen(true), { description: 'Show keyboard shortcuts', group: 'General' });

  const groups = useMemo(() => {
    const byGroup = new Map();
    for (const s of shortcuts) {
      const g = s.group || 'General';
      if (!byGroup.has(g)) byGroup.set(g, []);
      byGroup.get(g).push(s);
    }
    return [...byGroup.entries()];
  }, [shortcuts]);

  return (
    <Modal isOpen={sheetOpen} onClose={() => setSheetOpen(false)} title="Keyboard shortcuts" size="md">
      <div className="modal-body shortcut-sheet">
        {groups.map(([group, items]) => (
          <section key={group} className="shortcut-group">
            <h4 className="shortcut-group-title">{group}</h4>
            <ul className="shortcut-list">
              {items.map((s, i) => (
                <li key={`${s.keys}-${i}`} className="shortcut-row">
                  <span className="shortcut-description">{s.description}</span>
                  <span className="shortcut-keys" aria-label={formatShortcut(s.keys).join(' then ')}>
                    {formatShortcut(s.keys).map((label, j) => (
                      <React.Fragment key={j}>
                        {j > 0 && <span className="shortcut-then">then</span>}
                        <kbd>{label}</kbd>
                      </React.Fragment>
                    ))}
                  </span>
                </li>
              ))}
            </ul>
          </section>
        ))}
        {groups.length === 0 && <p className="text-muted">No shortcuts registered on this page.</p>}
      </div>
    </Modal>
  );
}
